var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d48f581d-d465-4626-95d3-28cbcb8ccd51",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-835a7c3a-db10-4d62-8067-254dceaa3ae7 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-835a7c3a-db10-4d62-8067-254dceaa3ae7",
    d: "M21.96,11.81h-3.18c-.55,0-1,.45-1,1s.45,1,1,1h2.18v6.35h-9.92v-6.35h2.18c.55,0,1-.45,1-1s-.45-1-1-1h-3.18c-.55,0-1,.45-1,1v8.35c0,.55.45,1,1,1h11.92c.55,0,1-.45,1-1v-8.35c0-.55-.45-1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-835a7c3a-db10-4d62-8067-254dceaa3ae7",
    d: "M13.61,14.79l2.39,4.14,2.39-4.14h-1.64v-3.95c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.95h-1.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/Paste.30b40b82a96e4572e4fb4cac577e62ee.svg";
export { ForwardRef as ReactComponent };